import markUrl from '../assets/saragossa-mark.svg';

export function LoadingState({ label = 'Loading your book…' }: { label?: string }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <img src={markUrl} alt="" className="brand-art animate-pulse" style={{ height: 48, width: 'auto', marginBottom: 24, opacity: 0.7 }} draggable={false} />
      <p style={{ fontSize: 13, color: 'var(--text-2)' }}>{label}</p>
    </div>
  );
}
